<style scoped lang="scss">
  @import '@/assets/styles/variables.scss';
  .anchor {
    position: relative;
  }
  .toggle {
    cursor: pointer;
    &.showing {
      // style when open
    }
  }
  .menu {
    position: absolute;
    padding: 0px;
    top: 5px;
    left: 0px;
    width: 100%;
    z-index: 999;
  }
</style>


<template>
  <div class="dropdown flex-v">
    <!-- toggle -->
    <div class="toggle" @click.stop="toggle" :class="{showing}">
      <slot name="toggle">Toggle</slot>
    </div>
    <!-- menu -->
    <div class="anchor">
      <c-dismiss class="menu" ref="menu" @opened="showing=true" @closed="showing=false">
        <slot name="menu">Menu</slot>
      </c-dismiss>
    </div>
  </div>
</template>


<script>
export default {
  name: 'dropdown',
  data() {
    return {
      showing: false,
    };
  },
  methods: {
    toggle() {
      this.$refs.menu.toggle();
    },
  },
};
</script>
